import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-download-icon',
  templateUrl: './lib-download-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibDownloadIconComponent {}
